import {
  CustomGetVehicleDailyFormWorkOrdersQuery,
  CustomGetVehicleDailyFormWorkOrdersQueryVariables,
  useCustomGetVehicleDailyFormWorkOrdersQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetVehicleDailyFormWorkOrders({
  variables,
}: {
  variables: CustomGetVehicleDailyFormWorkOrdersQueryVariables;
}) {
  const { data: graphqlData, error, loading, fetchMore: more } = useCustomGetVehicleDailyFormWorkOrdersQuery({
    variables,
  });

  const getData = useCallback((data?: CustomGetVehicleDailyFormWorkOrdersQuery) => {
    return data?.getDailyFormWorkOrders?.data || [];
  }, []);

  const getPaginatorInfo = useCallback((data?: CustomGetVehicleDailyFormWorkOrdersQuery) => {
    return data?.getDailyFormWorkOrders?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => getData(graphqlData), [getData, graphqlData]);
  const paginatorInfo = useMemo(() => getPaginatorInfo(graphqlData), [getPaginatorInfo, graphqlData]);

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          ...variables,
          page,
        },
      });
    },
    [more, variables]
  );

  return { data, error, loading, paginatorInfo, fetchMore } as const;
}
